import { render, staticRenderFns } from "./InsuranceDrugCode.vue?vue&type=template&id=2596c66a&scoped=true&"
import script from "./InsuranceDrugCode.vue?vue&type=script&lang=js&"
export * from "./InsuranceDrugCode.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceDrugCode.vue?vue&type=style&index=0&id=2596c66a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2596c66a",
  null
  
)

export default component.exports